export default __webpack_public_path__ + "static/media/graignesmini.9c6db8b2.jpg";